<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Examples/Generic_Types/The_Typer_Definition';
    let nextLink= '/Examples/External_Components/The_CourseSchedule_DSL';
    
    import Figure from "$lib/figures/Figure.svelte";
</script>

<PrevNextSection {prevLink} {nextLink} />



<SectionComponent tag="h1" 
  id="using-external-svelte-components-1"
  bind:intersecting={visibleById["using-external-svelte-components-1"]}
  onIntersectChange={(visible) => setVisible("using-external-svelte-components-1", visible)}
>Using External Svelte Components</SectionComponent>
<p>Freon offers a variety of native <a href="https://svelte.dev/" target="_blank">Svelte</a> components, each
associated with one of the box types in the
<a
  href="/Documentation/Under_the_Hood/Editor_Framework"
>editor framework</a>. You can significantly modify their appearance
via <a
  href="/Documentation/Defining_an_Editor/Styling"
>styling</a>.
However, you can give the editor a completely different look—or add custom functionality—
by incorporating your own Svelte components, whether from a library or custom-made. For an introduction, see
<a
  href="/Documentation/Customizations/External_Components"
>customization using external components</a>.</p>
<p>In this extended example, you’ll learn how to use external Svelte components to customize the Freon editor.
We’ll demonstrate how to add icons and buttons, use an Accordion component from a library, and create
a sorted table component. Since the complementary web app already uses
the <a href="https://flowbite-svelte.com/" target="_blank">Flowbite Svelte</a> UI library, we’ll use it in our example.
You’re free to choose any HTML component library and CSS tooling you prefer.</p>
<p>The source code for this example is available on GitHub—see
<a
  href="/Documentation/Overview/Getting_Started#creating-a-project-2"
>Getting Started</a>.
Choose the language <strong>CourseSchedule</strong>. The files for each phase of the example are in folders
named <code>phase1</code>, <code>phase2</code>, and so on.</p>
<p>When following along in your IDE, you may notice that after regeneration the browser occasionally shows a blank page.
This happens because the browser refresh is sometimes faster than the regeneration process. (In the browser’s developer
tools console you’ll see <code>Uncaught SyntaxError: Unexpected end of input</code>.) Don’t worry—just reload the page and everything
will work correctly.</p>


<PrevNextSection {prevLink} {nextLink} />